






































































































import { Component, Vue } from "vue-property-decorator";
import SideTabRightQuick from "@/components/QuickSideTabRight.vue";
import { WorkProgressState } from "@/model/WorkProgressState";
import { WorkProgressStateData } from "@/model/WorkProgressStateData";
import Navigation from "@/components/Navigation.vue";
import SubHeader from "@/components/SubHeader.vue";
import Number from "@/shared/filters/Number.ts";
import Header from "@/components/Header.vue";
import { Getter, Action } from "vuex-class";

import { CouponData } from "@/model/Coupon";
import { CarSelectData } from "@/model/CarSelection";
import { CarSelectQuickInfoData } from "@/model/CarSelectionQuickInfo";
import { CarSelectQuickInfoCustomerData } from "@/model/CarSelectionQuickInfoCustomer";
import { QuickMitsumoriQrInfo } from "@/model/quickMitsumoriQrInfo";

import { NavigationsQM, NavigationItem } from "@/model/NavigationItem";
import { NAVIGATION_STATUS } from "@/model/NavigationStatus";
import requestService from "@/service/requestService";
import { UserService } from "@/service/UserService";
import { SocketControllers } from "@/service/SocketControllers";
import { deepCopy } from "@/service/util";

import VueQrcode from "@chenfengyuan/vue-qrcode";

@Component({
  components: {
    Header,
    SubHeader,
    Navigation,
    appSideTabRightQuick: SideTabRightQuick,
    VueQrcode
  },
  filters: {
    Number
  }
})
export default class MainQuick extends Vue {
  isUserMode = false;
  activePage: number = 1;
  progressState: any = {
    sknWorkProgressStateId: 1,
    sknWorkProgressStateNm: "見積中"
  };
  info: any = {
    customerName: "上",
    soukou: 10000,
    soukouUnitKbn: 1,
    modelNm: "軽自動車",
    nyuukoRireki: "なし",
    nenshiki: "13年未満",
    torokubango: "5945",
    frontStaff: "平井 康博",
    fTire: "195/55/R15 ｲﾝﾁ",
    rTire: "195/55/R15 ｲﾝﾁ"
  };

  initialNavItems: NavigationItem[] = [
    {
      num: 1,
      screenId: "1",
      screenCd: "",
      screenNm: "車両情報",
      page: "quickinfo",
      status: "1",
      isNavigation: 1
    },
    {
      num: 2,
      screenId: "2",
      screenCd: "",
      screenNm: "品目選択",
      page: "quickitemselection",
      status: "1",
      isNavigation: 1
    },
    {
      num: 3,
      screenId: "3",
      screenCd: "quickmitsumori",
      screenNm: "見積結果",
      page: "quickmitsumori",
      status: "0",
      isNavigation: 1
    }
  ];

  nenshikiItems: any = [
    {
      nenshikiCd: "1",
      nenshikiNm: "13年未満車",
    },
    {
      nenshikiCd: "2",
      nenshikiNm: "13年～18年未満車",
    },
    {
      nenshikiCd: "3",
      nenshikiNm: "18年経過車",
    }
  ];

  carForm: any = {};
  carFormQuickInfo: any = {};
  customerInfo: any = {};
  kbnJidousha: any = [];
  staffs: any = [];
  selectTabNum: number = 0;

  totalShohiyou: any = {
    totalZk: 0,
    totalZn: 0,
    isConfirm: 0
  };

  totalCoupon: any = {
    subTotalZk: 0,
    subTotalZn: 0,
    isConfirm: 0
  };

  totalRecommend: any = {
    totalZk: 0,
    totalZn: 0,
    isConfirm: 0
  };

  option: any = {
    errorCorrectionLevel: "M",
    maskPattern: 0,
    margin: 0,
    scale: 2,
    width: 120,
    color: {
      dark: "#000000FF",
      light: "#FFFFFFFF"
    }
  }

  public reqService: requestService = new requestService();
  public sktControll: SocketControllers = new SocketControllers();

  @Getter("currentState", { namespace: "CarSelection" })
  currentState: CarSelectData;

  @Getter("currentState", { namespace: "CarSelectionQuickInfo" })
  currentStateQuickInfo: CarSelectQuickInfoData;

  @Getter("currentState", { namespace: "CarSelectionQuickInfoCustomer" })
  currentStateQuickInfoCustomer: CarSelectQuickInfoCustomerData;

  @Getter("currentState", { namespace: "NavigationsQM" })
  currentStateNavigationsQM: NavigationsQM;

  @Action("setState", { namespace: "NavigationsQM" })
  setStateNavigationsQM: any;

  @Getter("hasData", { namespace: "Shohiyou" })
  hasCostData: boolean;
  @Getter("total", { namespace: "Shohiyou" })
  costDataTotal: any;

  @Getter("total", { namespace: "Coupon" })
  couponDataTotal: any;

  @Getter("currentState", { namespace: "QuickMitsumoriQrInfo" })
  currentStateQuickMitsumoriQrInfo: QuickMitsumoriQrInfo;

  @Action("setState", { namespace: "QuickMitsumoriQrInfo" })
  setStateQuickMitsumoriQrInfo: any;

  @Action("clearState", { namespace: "QuickMitsumoriQrInfo" })
  clearStateQuickMitsumoriQrInfo: any;

  /** 2021-07-28 sh #6989 implements quick mitsumori(priority 2). [START] */
  @Getter("currentStateSknQuickMitsumoriId", { namespace: "CarSelectionQuickInfo" })
  sknQuickMitsumoriId: any;
  /** 2021-07-28 sh #6989 implements quick mitsumori(priority 2). [END] */

  /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [START] */
  socketPath: any = "";
  /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [END] */

  get workState() {
    let { sknWorkProgressStateId, sknWorkProgressStateNm } = this.progressState;
    let objStatus: WorkProgressState =
      WorkProgressStateData[sknWorkProgressStateId];
    if (!sknWorkProgressStateId) {
      sknWorkProgressStateId = 0;
    }
    objStatus = WorkProgressStateData[sknWorkProgressStateId];

    let name = "";
    let color = "#000";
    if (objStatus != null) {
      color = objStatus.color;
      if (sknWorkProgressStateNm) {
        name = sknWorkProgressStateNm;
      } else {
        name = objStatus.text;
      }
    }
    return { color, name };
  }

  onChangePage(page: number) {
    if (+this.navItems[page].status < +NAVIGATION_STATUS.ACTIVE) {
      let navItemQM = deepCopy(this.currentStateNavigationsQM);
      navItemQM.items[page].status = NAVIGATION_STATUS.ACTIVE;
      this.setStateNavigationsQM(navItemQM);
    }
    this.activePage = page;
    /** 2021-07-19 sh #6989 quick mitsumori for customer screen. (priority2) [START] */
    // this.$router.push({ name: this.navItems[page].page });
    let navItemPage = this.$route.meta == 'user' ? 'user-' + this.navItems[page].page : this.navItems[page].page;
    if (this.$route.meta == 'user' && page == 0 && this.sknQuickMitsumoriId) {
      this.$router.push({ name: "user-quickinfo", params: { code: this.sknQuickMitsumoriId } });
    } else {
      this.$router.push({ name: navItemPage });
    }
    /** 2021-07-19 sh #6989 quick mitsumori for customer screen. (priority2) [END] */
  }

  created() {
    /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [START] */
    this.sktControll.connectSocket(this.onConnect);
    /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [END] */

    this.reqService.getKbnSkns("skn_jidousha_shubetsu", "7101").then(
      (res: any) => {
        if (res) {
          this.$set(this, "kbnJidousha", res);
        }
      },
      (err: any) => {}
    );
    this.reqService.getStaffFront().then(
      (res: any) => {
        if (res) {
          this.staffs = res;
        }
      },
      (err: any) => {
        this.staffs = [];
      }
    );

    let objNavQM: NavigationsQM = {
      items: this.initialNavItems
    }

    /** 2021-07-19sh #6989 quick mitsumori for customer screen. (priority2) [START] */
    // this.isUserMode = this.$route.meta === "user";
    this.isUserMode = false; // (this.$route.meta === "user" || this.$route.path === "quick");
    /** 2021-07-19sh #6989 quick mitsumori for customer screen. (priority2) [END] */
    this.carForm = this.currentState;
    this.carFormQuickInfo = this.currentStateQuickInfo;
    this.customerInfo = this.currentStateQuickInfoCustomer;
    if (this.carFormQuickInfo.sknQuickMitsumoriId) {
      objNavQM.items[0].status = NAVIGATION_STATUS.REGISTER;
    }

    this.setStateNavigationsQM(objNavQM);
    // this.navItems = this.currentStateNavigationsQM.items;

    this.getSeibi();    

    this.totalShohiyou = this.costDataTotal;
    this.totalCoupon = this.couponDataTotal;

    this.getQuickMitsumoriQrInfo();

    // console.log("mainQuick.created totalCoupon => ",this.totalCoupon);
  }

  getSeibi() {
    if (this.hasCostData) {
    } else {
      const userService = new UserService();
      userService.getAllDataQM();
    }
  }

  get navItems() {
    return this.currentStateNavigationsQM.items;
  }

  onRegister(data: {
    pageName: string;
    status: string;
    notCurrentActive: boolean;
  }) {
    console.log("mainQuick.onRegister START !!!! data => ", data);

    let navItemQM = deepCopy(this.currentStateNavigationsQM);

    /** 2021-07-19sh #6989 quick mitsumori for customer screen. (priority2) [START] */
    // let nav = navItemQM.items.filter((item: any) => item.page === data.pageName);
    let pageName = data.pageName.replace('user-', '');
    console.log("mainQuick.onRegister START !!!! pageName => ", pageName);
    let nav = navItemQM.items.filter((item: any) => item.page === pageName);
    /** 2021-07-19sh #6989 quick mitsumori for customer screen. (priority2) [END] */

    if (nav && nav.length > 0) {
      let page = nav[0].num;

      // ナビゲーションを更新しておく
      nav[0].status = NAVIGATION_STATUS.REGISTER;
      this.setStateNavigationsQM(navItemQM);

      if (page < this.initialNavItems.length) {
        this.onChangePage(page);
      } else {
        // どこにいく？
      }
    }
  }

  onOpenPage(data: {
    pageName: string;
    status: string;
    notCurrentActive: boolean;
  }) {
    console.log("mainQuick.onOpenPage => CALL!!");
  }

  get customerName() {
    if (!this.customerInfo) {
      return '上';
    }
    if (!this.customerInfo.kojinNmKjSei && !this.customerInfo.kojinNmKjMei) {
      return '上';
    }
    return this.customerInfo.kojinNmKjSei + '　' + this.customerInfo.kojinNmKjMei;
  }

  get jidoushaShubetsuName() {

    let obj = this.kbnJidousha.filter((item: any) => +item.kbnKey === +this.carForm.jidoushaShubetsu);

    if (obj && obj.length > 0) {
      return obj[0].value;
    }

    return "未選択";
  }

  get tourokuBangou() {

    if (!this.carFormQuickInfo) {
      return '-';
    }

    return this.carFormQuickInfo.srPlateAreaNm
    + " " + this.carFormQuickInfo.srPlateModelNm
    + " " + this.carFormQuickInfo.srPlateKanaNm
    + " " + this.carFormQuickInfo.srPlateNo;
  }

  get keikaShareki() {
    let nenshikiObj = this.nenshikiItems.filter((item: any) => item.nenshikiCd === this.carFormQuickInfo.keikaShareki);

    if (nenshikiObj && nenshikiObj.length > 0) {
      return nenshikiObj[0].nenshikiNm;
    }

    return "未選択";
  }

  get soukou() {
    let soukou = this.carForm.soukouUnitKbn == 1 ? this.carForm.soukouKm : this.carForm.soukouMile;
    return !soukou ? '-' : soukou;
  }

  get soukouUnitKbn() {
    return this.carForm.soukouUnitKbn == 1 ? "km" : "ﾏｲﾙ";
  }

  get frontTantousha() {
    let frontStaff = this.staffs.filter((item: any) => item.staffCd === this.carFormQuickInfo.frontTantoushaCd);
    return frontStaff && frontStaff.length > 0 ? frontStaff[0].staffNm : '-';
  }

  get fTireSizeInput() {
    if (this.carForm.fTireSizeInput) {
      return this.carForm.fTireSizeInput;
    }
    return '';
  }

  get rTireSizeInput() {
    if (this.carForm.rTireSizeInput) {
      return this.carForm.rTireSizeInput;
    }
    return '';
  }

  onActiveSideTab(num: number) {
    this.selectTabNum = num;
  }

  /**
   * おすすめ整備で保存操作がされた場合に、おすすめ情報をAPIを取得して、storeに格納する
   */
  onGetInspectRecommend() {
    const userService = new UserService();
    userService.getSeibi();
    userService.getSeibiAK3();
  }

  get isHasQrInfo() {
    let isOK = false;
    if (this.currentStateQuickMitsumoriQrInfo) {
      if (this.currentStateQuickMitsumoriQrInfo.isHasImg == 1) {
        return true;
      }
    }
    return isOK;
  }

  /**
   * クイック見積が保存されたら呼ばれる
   */
  onUpdateQuickMitsumoriQrInfo() {
    this.getQuickMitsumoriQrInfo();
  }

  getQuickMitsumoriQrInfo(){
    this.reqService.getQuickMitsumoriQrInfo(this.carFormQuickInfo.sknQuickMitsumoriId).then((res: any) => {

      // 一旦クリアしておく。
      this.clearStateQuickMitsumoriQrInfo();

      if (res) {
        const qrInfo = deepCopy(res);
        this.setStateQuickMitsumoriQrInfo(res);
      }
    }, (err: any) => {
      let objQrInfo: any = {
        id: null,
        sknQuickMitsumoriId: this.carFormQuickInfo.sknQuickMitsumoriId,
        isHasImg: null,
        base64QrImage: null
      }
      this.setStateQuickMitsumoriQrInfo(objQrInfo);
    });
  }

  get qrUrl() {
    let id = this.currentStateQuickMitsumoriQrInfo.id;
    let sknQuickMitsumoriId = this.currentStateQuickMitsumoriQrInfo.sknQuickMitsumoriId;
    // return `https://work.extreme-service.jp/skn/v1/qr/img/${sknQuickMitsumoriId}/${id}.png`;
    return this.currentStateQuickMitsumoriQrInfo.qrUrl;
  }

  get hasVehicleName() {
    if (this.customerInfo.vehicleNm) {
      return true;
    }
    return false;
  }

  get vehicleName() {
    return this.customerInfo.vehicleNm;
  }

  /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [START] */
  onConnect() {
      if (this.sktControll.checkSocket()) {
        this.socketPath = this.randomString();
        this.sktControll.setsocket(this.socketPath);
        /** やりたいことは、再読込なので、流用する */
        this.sktControll.socketInspectQm(this.onGetInspectRecommend);
      }
  }

  destroyed() {
    this.sktControll.freeSocketResources();
  }

  randomString(){
    var len = 24;
    var str = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890";
    var strLen = str.length;
    var result = "";

    for (var i = 0; i < len; i++) {
      result += str[Math.floor(Math.random() * strLen)];
    }

    return `qm${result}`;
  }
  /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [END] */
}
